import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Card, Col, Form, Row } from "reactstrap";

// Breadcrumb

import { FormHelperText, FormLabel, Grid, Stack, Typography } from "@mui/material";
import Helpers from "../../../helpers/helpers";

export default function UploadProductImagesNew({ images, multiple, values, setNotification, setFormValues, content, setContent, error }) {
    const [selectedFilesTemp, setSelectedFilesTemp] = useState()
    const [filesChange, setFiles] = useState([])

    useEffect(() => {
        setSelectedFilesTemp(values)
    }, [values]);
    const handleAcceptedFiles = async (files) => {
        const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
        const MAX_PHOTOS = 10; // Maximum number of photos allowed

        const currentPhotoCount = selectedFilesTemp?.length || 0;
        const remainingSlots = MAX_PHOTOS - currentPhotoCount;

        if (remainingSlots <= 0) {
            setNotification({
                open: true,
                msg: `You can only upload up to ${MAX_PHOTOS} photos.`,
                type: "warning",
            });
            return; // Stop processing
        }

        // Filter oversized files
        const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);
        const validFiles = files.filter((file) => file.size <= MAX_FILE_SIZE);

        if (oversizedFiles.length > 0) {
            setNotification({
                open: true,
                msg: `Some files are too large (max 10 MB). Please check and try again.`,
                type: "warning",
            });
        }

        if (validFiles.length === 0) {
            return; // No valid files to process
        }

        // Restrict the number of files to the remaining slots
        const filesToProcess = validFiles.slice(0, remainingSlots);

        if (validFiles.length > remainingSlots) {
            setNotification({
                message: `Only ${remainingSlots} more photos can be uploaded.`,
                type: "error",
            });
        }

        setFiles(filesToProcess); // Set valid files to be processed

        let tempConvert = selectedFilesTemp ? [...selectedFilesTemp] : []; // Clone to avoid direct mutation

        try {
            // Convert all valid files to base64
            const base64Images = await Promise.all(
                filesToProcess.map((file) => Helpers.getBase64Arry(file))
            );

            // Push each base64 image into tempConvert
            base64Images.forEach((base64) => {
                tempConvert.push({ image: base64, is_base_image: 1, is_thumbnail: 0 });
            });

            setSelectedFilesTemp(tempConvert); // Update state
            setFormValues((prevValues) => ({
                ...prevValues,
                product_images_details: tempConvert
            }))
        } catch (error) {
            console.error("Error converting files:", error);
        }
    };

    const handleDeleteFilesTemp = (id) => {
        const tempFile = selectedFilesTemp
        const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
            id !== idx
        )
        setSelectedFilesTemp(filteredFIle);
        setFormValues((prevValues) => ({
            ...prevValues,
            product_images_details: filteredFIle
        }))
    }

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Product Images ({selectedFilesTemp && selectedFilesTemp.length}/10)</FormLabel>
                <FormHelperText sx={{ color: "#737373" }}>{error?.product_images_details}</FormHelperText>
                <Dropzone
                    accept={images ? {
                        'image/jpeg': [],
                        'image/png': [],
                        'image/gif': [],
                        'video/mp4': [],
                    } :
                        {
                            "application/pdf": [],
                            "application/doc": [],
                            "application/docx": [],
                            "application/csv": [],
                        }
                    }
                    multiple={multiple || false}
                    onDrop={acceptedFiles =>
                        handleAcceptedFiles(acceptedFiles)
                    }
                >
                    {({ getRootProps, getInputProps }) => (
                        <div className="dropzone" style={{ backgroundColor: "#fafafa", minHeight: "170px", display: "flex", justifyContent: "center" }}>
                            <div
                                className="dz-message needsclick"
                                {...getRootProps()}
                            >
                                <input {...getInputProps()} />
                                <div className="">
                                    <i className="ri-upload-2-line" style={{ fontSize: "30px", color: "#d0d0d0" }}></i>
                                </div>
                                <Typography style={{ fontSize: "14px" }}><span style={{ color: "#7bb9fa" }}>Upload files</span> or drag and drop</Typography>
                                <Typography style={{ fontSize: "14px" }}>Maximum size 10MB and 1500x1500 pixels</Typography>
                            </div>
                        </div>
                    )}
                </Dropzone>
                <div
                    className="dropzone-previews mt-3"
                    id="file-previews"
                >
                    <Grid container spacing={1} gap={2.5}>
                        {selectedFilesTemp && selectedFilesTemp?.length > 0 && selectedFilesTemp.map((f, i) => {
                            return (
                                <Card
                                    style={{ border: "none" }}
                                    className="mt-1 mb-0 shadow-none dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                >
                                    <Grid item>
                                        <Stack flexDirection={"row"} justifyContent={"space-between"}>
                                            <div className="p-2">
                                                <img
                                                    data-dz-thumbnail=""
                                                    height="80"
                                                    style={{ objectFit: "contain" }}
                                                    className="avatar-sm rounded bg-light"
                                                    alt={` ${f.name || "product details"}`}
                                                    src={`${f.image}`}
                                                />
                                                <span>
                                                    <i style={{ color: "red", cursor: "pointer", position: "absolute", top: "-8px", right: "-10px", }} onClick={(e) => handleDeleteFilesTemp(i)} className="ri-close-circle-fill font-size-20"></i>
                                                </span>
                                            </div>
                                        </Stack>
                                    </Grid>


                                </Card>
                            );
                        })}
                    </Grid>

                </div>
            </Grid>
        </React.Fragment >
    );
}
